import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTING_INFORMACION_PAGO_PENSION, ROUTING_ESTADO_TRAMITE_PENSION } from '@constants/url.constant';
import { ModalController } from "@ionic/angular";
import { ModalDescargaCertificadoComponent } from '../modal-descarga-certificado/modal-descarga-certificado.component';
import { IInformationModal } from '@interfaces/modal.interface';
import { InformationModalComponent } from '@shared/components/information-modal/information-modal.component';
import { Util } from '@shared/common/utils/util';
import { CertificadoSaldosService } from '../../services/certificado-saldos.service';

interface DetailItem {
  label: string;
  value: string;
  isHeader?: boolean;
}

@Component({
  selector: 'app-status-card',
  templateUrl: './status-card.component.html',
  styleUrl: './status-card.component.scss',
  standalone: false
})
export class StatusCardComponent implements OnInit, OnDestroy {
  @Input() title: string = '';
  @Input() statusText: string = '';
  @Input() statusClass: string = '';
  @Input() infoBoxMessage: string | null = null;
  @Input() details: DetailItem[] = [];
  @Input() infoText: string | null = null;
  @Input() requestTitle: string | null = null;
  @Input() requestDescription: string | null = null;
  @Input() requestLink: string | null = null;
  @Input() requestLinkText: string | null = null;
  @Input() requestDescriptionInfoImportant: string | null = null;
  @Input() infoImportant: string | null = null;
  @Input() requestTitleImportant: string | null = null;
  @Input() infoImportantStrong: string | null = null;
  @Input() infoImportantInnerHTML: string | null = null;
  @Input() tieneCertificadoSaldos: boolean = false;
  @Input() tieneCertificadoOfertas: boolean = false;
  @Input() esCompaniaSeguro: boolean = false;
  @Output() descargarCertificadoOfertas = new EventEmitter<void>();
  @Input() hayDetails: boolean = true;
  lanzaEncuesta: boolean = false;
  constructor(
    private readonly router: Router,
    private readonly modalCtrl: ModalController,
    private readonly util: Util,
    private readonly certificadoSaldosService: CertificadoSaldosService
  ) { }

  goToPagoPension() {
    this.router.navigate([ROUTING_INFORMACION_PAGO_PENSION.INFORMACION_PAGO_PENSION_BASE,
    ROUTING_INFORMACION_PAGO_PENSION.INFORMACION_PAGO_PENSION_URL]);
  }

  ngOnInit() {
    this.lanzaEncuesta = true;
    setTimeout(() => {
      if (this.lanzaEncuesta)
        this.util.levantarEncuesta('estado-tramite-pension');
    }, 10000);
  }

  ngOnDestroy(): void {
    this.lanzaEncuesta = false;
  }

  async goToModalDescargaCertificado() {

    const token = await this.util.getIdToken();
    const responseCertificados = await this.certificadoSaldosService.getCerfificadoSaldos(token);

    const esCopiaCertificado = responseCertificados?.data?.datosCertificadoSaldo?.descripcionEmision.toLowerCase() === ROUTING_ESTADO_TRAMITE_PENSION.TIPO_DESCARGA_CERTIFICADO;

    if (esCopiaCertificado)
      await this.modalCerticadoDeSaldoDescargado(responseCertificados, esCopiaCertificado);
    else
      await this.openModalDescargaCertificados(responseCertificados, esCopiaCertificado);
  }

  private async openModalDescargaCertificados(responseCertificados?: any, esCopiaCertificado: boolean = false) {
    const modal = await this.modalCtrl.create({
      component: ModalDescargaCertificadoComponent,
      cssClass: "modal-descarga-certificado",
      componentProps: {
        certificadoData: responseCertificados,
        esCopiaCertificado: esCopiaCertificado
      }
    });
    await modal.present();
  }

  private async modalCerticadoDeSaldoDescargado(responseCertificados: any, esCopiaCertificado: boolean) {
    const modal = await this.modalCtrl.create({
      component: InformationModalComponent,
      cssClass: 'generic-modal-2',
    });

    const data: IInformationModal = {
      title: 'Ya descargaste tu certificado',
      description: ['Si decides continuar, obtendrás una copia del mismo certificado.'],
      primaryButtonText: 'Continuar',
      primaryButtonCallback: () => {
        void (async () => {
          await modal.dismiss();
          await this.openModalDescargaCertificados(responseCertificados, esCopiaCertificado);
        })();
      },
      closeButtonCallback: () => {
        modal.dismiss();
      },
    };

    modal.componentProps = { data };

    await modal.present();
  }


}
